import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/home",
      name: "home",
      component: Home
    },
    {
      path: "/platforms",
      name: "platforms",
      component: () =>
        import(/* webpackChunkName: "platforms" */ "./views/Platforms.vue")
    },
    {
      path: "/news",
      name: "news",
      component: () => import(/* webpackChunkName: "news" */ "./views/News.vue")
    },
    {
      path: "/team",
      name: "team",
      component: () => import(/* webpackChunkName: "team" */ "./views/Team.vue")
    },
    {
      path: "/pipeline",
      name: "pipeline",
      component: () =>
        import(/* webpackChunkName: "pipeline" */ "./views/Pipeline.vue")
    },
    {
      path: "/clinical-trials",
      name: "clinicaltrials",
      component: () =>
        import(/* webpackChunkName: "clinicaltrials" */ "./views/ClinicalTrials.vue")
    },
    {
      path: "/clinical-trials/expanded-access-policy",
      name: "expandedaccesspolicy",
      component: () =>
        import(/* webpackChunkName: "expandedaccesspolicy" */ "./views/ExpandedAccessPolicy/ExpandedAccessPolicy.vue")
    },
    {
      path: "/clinical-trials/:id",
      name: "clinicaltrialdetail",
      component: () =>
        import(/* webpackChunkName: "clinicaltrialdetail" */ "./views/ClinicalTrialDetail.vue")
    },
    {
      path: "/publications",
      name: "publications",
      component: () =>
        import(
          /* webpackChunkName: "publications" */ "./views/Publications.vue"
        )
    },
    {
      path: "/careers",
      name: "careers",
      component: () =>
        import(/* webpackChunkName: "careers" */ "./views/Careers.vue")
    },
    {
      path: "/contact",
      name: "contact",
      component: () =>
        import(/* webpackChunkName: "contact" */ "./views/Contact.vue")
    },
    {
      path: "/disease-education",
      name: "diseaseeducation",
      component: () =>
        import(/* webpackChunkName: "diseaseeducation" */ "./views/DiseaseEducation.vue")
    },
    {
      path: "/privacy-notice",
      name: "privacynotice",
      component: () =>
        import(/* webpackChunkName: "privacynotice" */ "./views/PrivacyNotice.vue")
    },
    {
      path: "/terms-of-use",
      name: "termsofuse",
      component: () =>
        import(/* webpackChunkName: "termsofuse" */ "./views/TermsOfUse.vue")
    },
    {
      path: "*",
      redirect: "/home"
    }
  ]
});
